import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';

export interface DiffField {
    label: string;
    oldValue: any;
    newValue: any;
}

interface SaveDiffModalProps {
    open: boolean;
    diffs: DiffField[];
    onConfirm: () => void;
    onCancel: () => void;
}

const SaveDiffModal: React.FC<SaveDiffModalProps> = ({ open, diffs, onConfirm, onCancel }) => {
    return (
        <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
            <DialogTitle>Review Changes Before Saving</DialogTitle>
            <DialogContent>
                {diffs.length === 0 ? (
                    <Typography>No changes detected.</Typography>
                ) : (
                    <Table>
                        <TableBody>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold', color: 'error.main' }}>
                                    Before Save
                                </TableCell>
                                <TableCell align="center" sx={{ fontWeight: 'bold', color: 'success.main' }}>
                                    After Save
                                </TableCell>
                            </TableRow>
                            {diffs.map((diff, idx) => (
                                <TableRow key={idx}>
                                    <TableCell>
                                        <Typography fontWeight="bold">{diff.label}</Typography>
                                    </TableCell>
                                    <TableCell sx={{ color: 'error.main', backgroundColor: '#ffebee', fontWeight: 500 }}>
                                        {Array.isArray(diff.oldValue) ? diff.oldValue.map((line, i) => <div key={i}>{line}</div>) : String(diff.oldValue)}
                                    </TableCell>
                                    <TableCell sx={{ color: 'success.main', backgroundColor: '#e8f5e9', fontWeight: 500 }}>
                                        {Array.isArray(diff.newValue) ? diff.newValue.map((line, i) => <div key={i}>{line}</div>) : String(diff.newValue)}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} color="error" variant="contained">
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="primary" variant="contained" disabled={diffs.length === 0}>
                    Confirm & Save
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default SaveDiffModal;
